import React from "react";
import { Handle, Position } from "@xyflow/react";

/* eslint-disable react/prop-types */

const TYPE_ICONS = {
  visualtext: "article",
  flipcard: "flip",
  truefalse: "rule",
  mcq: "quiz",
};

const TYPE_COLORS = {
  visualtext: "#3b82f6",
  flipcard: "#8b5cf6",
  truefalse: "#f59e0b",
  mcq: "#10b981",
};

export default function ScenarioElementNode({ data, selected }) {
  const { elType, title } = data || {};
  const icon = TYPE_ICONS[elType] || "widgets";
  const color = TYPE_COLORS[elType] || "#94a3b8";

  return (
    <div
      style={{
        width: 180,
        height: 40,
        borderRadius: 8,
        background: "#ffffff",
        border: `1.5px solid ${selected ? "#a963f5" : "#e8eaf0"}`,
        boxShadow: selected
          ? "0 0 0 2px rgba(169,99,245,0.2), 0 1px 4px rgba(0,0,0,0.06)"
          : "0 1px 4px rgba(0,0,0,0.06)",
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "0 10px",
        fontFamily: "system-ui, sans-serif",
        cursor: "pointer",
        transition: "border-color 0.12s, box-shadow 0.12s",
        position: "relative",
      }}
    >
      <Handle
        type="target"
        position={Position.Left}
        style={{ background: "#a963f5", width: 7, height: 7, border: "none" }}
      />

      <span className="material-icons" style={{ fontSize: 14, color, flexShrink: 0 }}>
        {icon}
      </span>
      <span
        style={{
          fontSize: 11,
          fontWeight: 500,
          color: "#1e293b",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          flex: 1,
        }}
      >
        {title || elType}
      </span>

      <Handle
        type="source"
        position={Position.Right}
        style={{ background: color, width: 7, height: 7, border: "none" }}
      />
    </div>
  );
}
